import { render, staticRenderFns } from "./DreamC.vue?vue&type=template&id=64150afa&scoped=true&"
import script from "./DreamC.vue?vue&type=script&lang=js&"
export * from "./DreamC.vue?vue&type=script&lang=js&"
import style0 from "./DreamC.vue?vue&type=style&index=0&id=64150afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64150afa",
  null
  
)

export default component.exports